import ModalWizzardActivity from "../components/TableActivity";
import { PlusCircleIcon } from "components/Icons";

ModalWizzardActivity;

const getView = () => {
  const DictCtxView = {
    model: "sale_activity.activity",
    form_action: [],
    table_action: [],
    title: { field: "schedule", model: true },

    domain: [],

    webfields: {
      quota: { type: "numeric" },
      time_start: { type: "char" },
      time_end: { type: "char" },
      available: { type: "integer" },

      quantity: {
        type: "integer",
        required: true,
        editable: true,
        default: 1,
        min: 1,
      },
      state: { type: "char" },
      schedule: {
        type: "many2one",
        recSearch: () => [],
        model: "sale_activity.schedule",
        searchable: true,

        attrs: [
          "date_activity",
          "note",
          "kind.name",
          "kind.product.name",
          "kind.product.list_price",
          "kind.product.sale_uom",
          "kind.employee.party.name",
        ],
      },
      "schedule.kind.name": { type: "char" },

      employee: {
        type: "many2one",
        recSearch: () => [],
        model: "company.employee",
        searchable: true,
        attrs: ["id, party.name"],
      },

      add: {
        type: "button",
        color: "bluePresik",
        iconRight: <PlusCircleIcon className="h-4 w-4 fill-current" />,
      },
    },
    webtree: [
      { name: "time_start", width: "30%" },
      { name: "time_end", width: "30%" },
      { name: "quota", width: "30%" },
      { name: "available", width: "10%" },
      { name: "quantity" },
      { name: "add", width: "30%" },
    ],
    webform: [],
  };

  return DictCtxView;
};

export default { ctxView: getView };
